import { Loader, TilingSprite } from 'pixi.js';
import state from '../state';
import ticker from '../ticker';
import vars from '../vars';

class Clouds {
  constructor(parent) {
    this.parent = parent;

    this.backgroundCloudsFar = new TilingSprite(
      Loader.shared.resources['textures/CLOUDS_BACKGROUND_FAR'].texture, vars.layout.FRAME_WIDTH, 319,
    );
    this.backgroundCloudsMid = new TilingSprite(
      Loader.shared.resources['textures/CLOUDS_BACKGROUND_MID'].texture, vars.layout.FRAME_WIDTH, 374,
    );
    this.backgroundCloudsNear = new TilingSprite(
      Loader.shared.resources['textures/CLOUDS_BACKGROUND_NEAR'].texture, vars.layout.FRAME_WIDTH, 406,
    );
    this.foregroundClouds = new TilingSprite(
      Loader.shared.resources['textures/CLOUDS_FOREGROUND'].texture, vars.layout.FRAME_WIDTH, 100,
    );

    this.resize();

    this.frameHandler = () => { this.frame(); };
    this.introFrameHandler = () => { this.introFrame(); };

    ticker.add(this.introFrameHandler);

    this.parent.addChild(this.backgroundCloudsFar);
    this.parent.addChild(this.backgroundCloudsMid);
    this.parent.addChild(this.backgroundCloudsNear);
    this.parent.addChild(this.foregroundClouds);
  }

  resize() {
    this.foregroundClouds.zIndex = 2;
  }

  frame() {
    this.backgroundCloudsFar.tilePosition.x -= state.backgroundSpeed * ticker.speed * 1.2;
    this.backgroundCloudsMid.tilePosition.x -= state.backgroundSpeed * ticker.speed * 1.4;
    this.backgroundCloudsNear.tilePosition.x -= state.backgroundSpeed * ticker.speed * 1.6;
    this.foregroundClouds.tilePosition.x -= state.foregroundSpeed * ticker.speed * 1.1;
  }

  introFrame() {
    this.backgroundCloudsFar.tilePosition.x -= state.backgroundSpeed * ticker.speed * 0.2;
    this.backgroundCloudsMid.tilePosition.x -= state.backgroundSpeed * ticker.speed * 0.4;
    this.backgroundCloudsNear.tilePosition.x -= state.backgroundSpeed * ticker.speed * 0.6;
    this.foregroundClouds.tilePosition.x -= state.foregroundSpeed * ticker.speed * 0.8;
  }

  startSpawning() {
    ticker.remove(this.introFrameHandler);
    ticker.add(this.frameHandler);
  }
}

export default Clouds;
